import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { EventCalendar, EventTechnician, Paths } from 'src/app/models';
import { EventSummary } from 'src/app/models/event-summary';

@Injectable({
  providedIn: 'root',
})
export class EventHttpService {
  readonly http = inject(HttpClient);

  public createEvent(calendarEvent): Observable<EventCalendar> {
    return this.http.post<EventCalendar>('/events', calendarEvent);
  }

  public getEvents(): Observable<EventCalendar[]> {
    return this.http.get<EventCalendar[]>('/events');
  }

  public getEventsByCustomer(id) {
    return this.http.get<EventCalendar[]>(`/events_by_customer/${id}`);
  }

  public eventsUpdate(payload): Observable<EventCalendar> {
    return this.http.post<EventCalendar>('/events_update', payload);
  }

  public getCalendarEvents(payload: Object): Observable<EventCalendar> {
    return this.http.post<EventCalendar>(`/events`, payload);
  }

  public updateCalendarEvents(payload: Object) {
    return this.http.post(`/events_update`, payload);
  }

  public getEventsByDate(startDate) {
    return this.http.get<EventCalendar[]>(`/events_by_date/${startDate}`);
  }

  public getEventsByDates(startDate, endDate) {
    return this.http.get<EventCalendar[]>(
      `/events_by_dates/${startDate}/${endDate}`
    );
  }

  public updateEvent(id, calendarEvent) {
    return this.http.put<EventCalendar>(`/event/${id}`, calendarEvent);
  }

  public updateEventPartial(id, calendarEvent, projectStatusID) {
    return this.http.get(
      `/event_update/${id}/${calendarEvent}/${projectStatusID}`
    );
  }

  public updateEventDate(id, startDate, endDate) {
    return this.http.get(`/event_update_date/${id}/${startDate}/${endDate}`);
  }

  public deleteEvent(id) {
    return this.http.delete(`/event/${id}`);
  }

  public completeEvent(id) {
    return this.http.get(`/event_complete/${id}`);
  }

  public createEventTechnician(eventTechnician) {
    return this.http.post<EventTechnician>(
      '/event_technicians',
      eventTechnician
    );
  }

  public getBooks() {
    return this.http.get('/books');
  }

  public getClosestLocation(locations) {
    return this.http.post('/closest_location', locations);
  }

  public getPathsByDate(pathDate) {
    return this.http.get<Paths[]>(`/paths_by_date/${pathDate}`);
  }

  public getGeoCode(postcode) {
    return this.http.get(`/get_geocode/${postcode}`);
  }

  public getClientHistory(id, mod): Observable<EventSummary[]> {
    return this.http.get<EventSummary[]>(`/booking_history/${id}/${mod}`).pipe(
      map(events =>
        events.map((event: any) => ({
          id: event.Id,
          description: event.Subject,
          projectType: event.type,
          projectId: event.ProjectId,
          projectStatus: event.projectStatus,
          address: {
            id: Number(event.address),
            address1: event.address1,
            address2: event.address2,
            city: event.city,
            postcode: event.postcode,
          },
          startDate: event.StartTime,
          endDate: event.EndTime,
          dateCreated: event.date_created,
          userCreated: event.user_created,
          isAllDay: event.IsAllDay,
          isFixedArrival: event.IsFixedArrival,
          isHoliday: event.IsHoliday,
          isRecurring: event.IsRecurring,
          isReminder: event.IsReminder,
          daysToDelete: event.days_to_delete,
          technicians: event.TechnicianId,
          managedBy: event.managedBy,
        }))
      )
    );
  }
}
